import { ReactNode } from 'react';
import { Modal } from '../../../components/modal/modal';
import { Button } from '../../../components/button/button';
import { Div } from '../../../styles/styles';
import { H3, P } from '../../../styles/text';
import { lightTheme } from '../../../styles/theme';

/**
 * "Are you sure" for the destructive things the conversation modals offer.
 *
 * Same shape as every other confirmation in the admin (see
 * `DeleteCustomPriceModal`): the red heading, one sentence naming what is about
 * to happen, and the destructive button first.
 *
 * One component rather than one file per question, because the questions here
 * are neighbours - removing a member and leaving the group sit in the same
 * panel - and two copies of the same modal drift apart on the first change to
 * either. Everything specific stays at the call site: the sentence and the word
 * on the button. Shared by both apps: the merchant leaves a group through it
 * too.
 */
export const ChatConfirmModal = ({
  isOpen,
  message,
  confirmLabel,
  onClose,
  onConfirm,
  busy,
}: {
  isOpen: boolean;
  /** The sentence under the heading. A node, so it can name things in bold. */
  message: ReactNode;
  /** What the destructive button says - "Remove", "Leave". */
  confirmLabel: string;
  onClose: () => void;
  onConfirm: () => void;
  busy?: boolean;
}) => (
  <Modal
    isOpen={isOpen}
    closeModal={onClose}
    logo={false}
    /* Over the Group Details modal (130) that opened it. */
    zIndex={155}
  >
    <H3 $mb="8" $color={lightTheme.primary}>
      Are you sure
    </H3>
    <P $mb="16">{message}</P>

    <Div $flex $gap="16px">
      <Button $w="100%" $selected disabled={busy} onClick={onConfirm}>
        {confirmLabel}
      </Button>
      <Button $w="100%" $selected $gray onClick={onClose}>
        Cancel
      </Button>
    </Div>
  </Modal>
);
